/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRsvp,
    JsonRsvpFromJSON,
    JsonRsvpFromJSONTyped,
    JsonRsvpToJSON,
} from './JsonRsvp';

/**
 * 
 * @export
 * @interface ApiResultOfJsonRsvp
 */
export interface ApiResultOfJsonRsvp {
    /**
     * 
     * @type {JsonRsvp}
     * @memberof ApiResultOfJsonRsvp
     */
    data?: JsonRsvp;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvp
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonRsvp
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvp
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvp
     */
    result?: ApiResultOfJsonRsvpResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonRsvpResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonRsvpFromJSON(json: any): ApiResultOfJsonRsvp {
    return ApiResultOfJsonRsvpFromJSONTyped(json, false);
}

export function ApiResultOfJsonRsvpFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonRsvp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonRsvpFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonRsvpToJSON(value?: ApiResultOfJsonRsvp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonRsvpToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

